module.exports = __webpack_public_path__ + "static/media/feishu2-0001.d4ac680c.png";